import React, { useState } from "react";
import ArrowRightSvg from "../../resources/SvgComponents/ArrowRightSvg";
import ArrowUpSvg from "../../resources/SvgComponents/ArrowUpSvg/ArrowUpSvg";
import { Link } from "gatsby";

import {
  StyledContainer,
  StyledTitle,
  StyledIcon,
  StyledDescription,
} from "./FaqItemStyle";

const renderAnchor = (href, name, type) => (
  <>
    {type === "a" && (
      <a
        onClick={(e) => e.stopPropagation()}
        rel="noreferrer"
        aria-label={name}
        target="_blank"
        href={href}
      >
        {name}
      </a>
    )}
    {type === "link" && <Link to={`/${href}`}>{name}</Link>}
  </>
);

const FaqItem = ({ item }) => {
  const [isOpen, setOpen] = useState(false);
  const handleToggle = () => {
    setOpen((state) => !state);
  };
  return (
    <StyledContainer onClick={handleToggle}>
      <StyledTitle>{item.title}</StyledTitle>
      <StyledIcon isOpen={isOpen}>
        {!isOpen && <ArrowRightSvg />}
        {isOpen && <ArrowUpSvg />}
      </StyledIcon>
      {isOpen && (
        <StyledDescription>
          {item.withLinks ? (
            <>
              {item.beforeLink1Desc && item.beforeLink1Desc}
              {item.link1 &&
                renderAnchor(item.link1, item.link1Name, item.type)}
              {item.afterLink1Desc && item.afterLink1Desc}
              {item.link2 &&
                renderAnchor(item.link2, item.link2Name, item.type)}
              {item.afterLink2Desc && item.afterLink2Desc}
            </>
          ) : (
            item.description
          )}
        </StyledDescription>
      )}
    </StyledContainer>
  );
};
const FaqItems = ({ data }) => {
  return data.map((item, index) => <FaqItem key={index} item={item} />);
};
export default FaqItems;
